"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompanyServiceLive = void 0;
const mystake_common_sdk_1 = require("@boulevard1/mystake-common-sdk");
const HttpProvider_1 = require("../utils/HttpProvider");
class CompanyServiceLive {
    addPaymentMethod(companyId, nameOnCard, cardNumber, expiry, cvv, isPaidPlan) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield HttpProvider_1.httpProvider.post(`/company/${companyId}/add-payment-method`, {
                nameOnCard,
                cardNumber,
                expiry,
                cvv,
                isPaidPlan,
            });
            return response.data;
        });
    }
    addCompany(companyRequestBody) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield HttpProvider_1.httpProvider.post("/company", companyRequestBody);
            return response.data;
        });
    }
    setSelectedPlan(companyId, selectedPlanId) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield HttpProvider_1.httpProvider.patch(`/company/${companyId}`, {
                selectedPlanId,
            });
            return response.data;
        });
    }
    cancelCompanyCreation(companyId) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield HttpProvider_1.httpProvider.delete(`/company/${companyId}`);
            return response.data;
        });
    }
    updateLastAccess(companyId) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield HttpProvider_1.httpProvider.patch(`/company/${companyId}/last-access`);
            return response.data;
        });
    }
    updateCompanyAuthorizationDetails(updateCompanyAuthorizationDetailsBody) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield HttpProvider_1.httpProvider.patch(`/company/${updateCompanyAuthorizationDetailsBody.companyId}/authorize-mystake`, updateCompanyAuthorizationDetailsBody);
            return response.data;
        });
    }
    getCompanies(search = "", active = false) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const response = (yield HttpProvider_1.httpProvider.get(`/company?search=${search}&active=${active}`));
                return {
                    status: response.data.status,
                    message: response.data.message,
                    payload: response.data.payload,
                };
            }
            catch (err) {
                return {
                    status: false,
                    message: err.message,
                    payload: [],
                };
            }
        });
    }
    getCompanyInfo(companyId) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield HttpProvider_1.httpProvider.get(`/company/${companyId}/info`);
            return response.data;
        });
    }
    getCompanyByAcn(acn) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield HttpProvider_1.httpProvider.get(`/company/acn/${acn}`);
            return response.data;
        });
    }
    getAdminInfo(companyId) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield HttpProvider_1.httpProvider.get(`/company/${companyId}/admin`);
            return response.data;
        });
    }
    updateAuthorizer(companyId, nomineeRequest) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield HttpProvider_1.httpProvider.patch(`/company/${companyId}/authorize-nominee`, nomineeRequest);
            return response.data;
        });
    }
    unsetKYCAuthorizationDetails(companyId) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield HttpProvider_1.httpProvider.patch(`/company/${companyId}/unset-kyc-authorization`);
            return response.data;
        });
    }
    getCompanyRegister(companyId, keyword, activeClassId, page, rowsPerPage, sortBy, sortOrder) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield HttpProvider_1.httpProvider.get(`/company/${companyId}/register?keyword=${keyword}&activeClassId=${activeClassId}&page=${page}&rowsPerPage=${rowsPerPage}&sortBy=${sortBy}&sortOrder=${sortOrder}`);
            return response.data;
        });
    }
    getShareholderDetails(companyId, shareholderId) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield HttpProvider_1.httpProvider.get(`/company/${companyId}/share-detail/${shareholderId}`);
            return response.data;
        });
    }
    getShareholder(companyId, shareholderId) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield HttpProvider_1.httpProvider.get(`/company/${companyId}/shareholder/${shareholderId}`);
            return response.data;
        });
    }
    getAllTransactions(companyId) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield HttpProvider_1.httpProvider.get(`/company/${companyId}/transactions`);
            return response.data;
        });
    }
    getAllTransactionsByShareholderId(companyId, shareholderId, // share holder identification number
    sortBy, sortOrder) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield HttpProvider_1.httpProvider.get(`/company/${companyId}/share-detail/${shareholderId}/transactions?sortBy=${sortBy}&sortOrder=${sortOrder}`);
            return response.data;
        });
    }
    issueSharesToNewShareholder(companyId, shareholder) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield HttpProvider_1.httpProvider.post(`/company/${companyId}/shareholder`, shareholder);
            return response.data;
        });
    }
    createInvestorProfile(companyId, shareholder) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield HttpProvider_1.httpProvider.post(`/company/${companyId}/investors`, shareholder);
            return response.data;
        });
    }
    updateInvestorProfile(companyId, shareholder, overrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield HttpProvider_1.httpProvider.patch(`/company/${companyId}/investors/${shareholder._id}/update`, {
                shareholder,
                overrides,
            });
            return response.data;
        });
    }
    cloneInvestorRequests(targetCompanyId, investors) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield HttpProvider_1.httpProvider.post(`/company/${targetCompanyId}/clone-investors`, { investors });
            return response.data;
        });
    }
    updateShareholder(companyId, shareholderId, shareholder) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield HttpProvider_1.httpProvider.post(`/company/${companyId}/shareholder/${shareholderId}/update`, shareholder);
            return response.data;
        });
    }
    getSharePriceHistory(companyId, sortBy, sortOrder, filterByShareClass) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield HttpProvider_1.httpProvider.get(`/company/${companyId}/share-price-history?sortBy=${sortBy}&sortOrder=${sortOrder}&filterByShareClass=${filterByShareClass}`);
            return response.data;
        });
    }
    createNewShareClass(companyId, createNewShareClassData) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield HttpProvider_1.httpProvider.put(`/company/${companyId}/share-class`, createNewShareClassData);
            return response.data;
        });
    }
    getShareStructure(companyId) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield HttpProvider_1.httpProvider.get(`/company/${companyId}/share-structure`);
            return response.data;
        });
    }
    getShareCapitalStructure(companyId) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield HttpProvider_1.httpProvider.get(`/company/${companyId}/share-capital-structure`);
            return response.data;
        });
    }
    getCapitalStructureAndRegisterDifference(companyId) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield HttpProvider_1.httpProvider.get(`/company/${companyId}/capital-structure-register-difference`);
            return response.data;
        });
    }
    isCapitalStructureAndRegisterDifferent(companyId) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield HttpProvider_1.httpProvider.get(`/company/${companyId}/is-capital-structure-register-different`);
            return response.data.payload;
        });
    }
    setSharePrice(companyId, shareClassId, setSharePriceRequestBody) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield HttpProvider_1.httpProvider.patch(`/company/${companyId}/share-class/${shareClassId}/price`, setSharePriceRequestBody);
            return response.data;
        });
    }
    getAdminViewInfo(companyId) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield HttpProvider_1.httpProvider.get(`/company/${companyId}/admin-view`);
            return response.data;
        });
    }
    getCompanyInformationPageData(companyId) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield HttpProvider_1.httpProvider.get(`/company/${companyId}/information`);
            return response.data;
        });
    }
    getAdminList(companyId) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield HttpProvider_1.httpProvider.get(`/company/${companyId}/admin-list`);
            return response.data;
        });
    }
    addNewAdmin(companyId, addNewAdminRequestBody) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield HttpProvider_1.httpProvider.post(`/company/${companyId}/create-admin`, addNewAdminRequestBody);
            return response.data;
        });
    }
    resendAdminInvite(companyId, adminUserId) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield HttpProvider_1.httpProvider.post(`/company/${companyId}/admin/${adminUserId}/resend-invite`);
            return response.data;
        });
    }
    removeAdmin(companyId, adminUserId) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield HttpProvider_1.httpProvider.delete(`/company/${companyId}/admin/${adminUserId}`);
            return response.data;
        });
    }
    getShareholders(companyId, keyword = "", excludeShareholderId = "") {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield HttpProvider_1.httpProvider.get(`/company/${companyId}/shareholder?keyword=${keyword}&excludeShareholderId=${excludeShareholderId}`);
                return response.data;
            }
            catch (err) {
                return {
                    status: false,
                    message: err.message,
                    payload: [],
                };
            }
        });
    }
    getShareholdersV2(companyId, keyword = "") {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield HttpProvider_1.httpProvider.get(`/company/${companyId}/shareholder/getShareholders/getShareholdersV2?keyword=${keyword}`);
                return response.data;
            }
            catch (err) {
                return {
                    status: false,
                    message: err.message,
                    payload: [],
                };
            }
        });
    }
    getShareholdersByTypeAndShareClass(companyId, keyword, shareClassId, investorTypes, sortBy, sortOrder, page, rowsPerPage, sharesInputType, maxSharesTradable, deniedShareholders, activeStatus, auctionShareholderIds) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield HttpProvider_1.httpProvider.post(`/company/${companyId}/shareholder/getShareholders/getShareholdersByTypeAndShareClass`, {
                    keyword,
                    shareClassId,
                    investorTypes,
                    sortBy,
                    sortOrder,
                    page,
                    rowsPerPage,
                    sharesInputType,
                    maxSharesTradable,
                    deniedShareholders,
                    activeStatus,
                    auctionShareholderIds,
                });
                return response.data;
            }
            catch (err) {
                return {
                    status: false,
                    message: err.message,
                    payload: { shareholders: [], count: 0, allShareholders: [] },
                };
            }
        });
    }
    issueSharesToExistingShareholder(companyId, shareholderId, transaction) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield HttpProvider_1.httpProvider.put(`/company/${companyId}/shareholder/${shareholderId}`, { transaction });
            return response.data;
        });
    }
    transferSharesToExistingShareholder(companyId, fromShareholderId, toShareholderId, transaction) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield HttpProvider_1.httpProvider.put(`/company/${companyId}/shareholder/${fromShareholderId}/to/${toShareholderId}/transfer`, { transaction });
            return response.data;
        });
    }
    transferSharesToNewShareholder(companyId, fromShareholderId, shareholder) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield HttpProvider_1.httpProvider.post(`/company/${companyId}/shareholder/${fromShareholderId}/transfer`, shareholder);
            return response.data;
        });
    }
    updateRegisteredAddress(companyId, newRegisteredAddressData, authorisingOfficer) {
        return __awaiter(this, void 0, void 0, function* () {
            if (newRegisteredAddressData) {
                const response = yield HttpProvider_1.httpProvider.patch(`/company/${companyId}/registered-address`, {
                    careOf: newRegisteredAddressData.careOf,
                    line2: newRegisteredAddressData.line2,
                    street: newRegisteredAddressData.street,
                    locality: newRegisteredAddressData.locality,
                    state: newRegisteredAddressData.state,
                    postcode: newRegisteredAddressData.postcode,
                    country: newRegisteredAddressData.country,
                    authorisingOfficer,
                });
                return response.data.status;
            }
            return false;
        });
    }
    updatePrincipalPlaceOfBusinessAddress(companyId, newPrincipalPlaceOfBusinessAddressData, authorisingOfficer) {
        return __awaiter(this, void 0, void 0, function* () {
            if (newPrincipalPlaceOfBusinessAddressData) {
                const response = yield HttpProvider_1.httpProvider.patch(`/company/${companyId}/principal-place-of-business-address`, {
                    careOf: newPrincipalPlaceOfBusinessAddressData.careOf,
                    line2: newPrincipalPlaceOfBusinessAddressData.line2,
                    street: newPrincipalPlaceOfBusinessAddressData.street,
                    locality: newPrincipalPlaceOfBusinessAddressData.locality,
                    state: newPrincipalPlaceOfBusinessAddressData.state,
                    postcode: newPrincipalPlaceOfBusinessAddressData.postcode,
                    country: newPrincipalPlaceOfBusinessAddressData.country,
                    authorisingOfficer,
                });
                return response.data.status;
            }
            return false;
        });
    }
    importCSV(companyId, csvFile) {
        return __awaiter(this, void 0, void 0, function* () {
            const formData = new FormData();
            formData.append("csv", csvFile, csvFile.name);
            const response = yield HttpProvider_1.httpProvider.post(`/company/${companyId}/import-csv`, formData);
            return response.data;
        });
    }
    createNewAdminAccount(adminUserId, companyId, createNewAdminAccountRequestBody) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield HttpProvider_1.httpProvider.post(`/company/${companyId}/admin/${adminUserId}`, createNewAdminAccountRequestBody);
            const customToken = response.data.payload;
            return {
                status: true,
                message: "Account creation successful",
                payload: customToken,
            };
        });
    }
    getInvestorInvitations(companyId, keyword, page, rowsPerPage, sortOrder) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield HttpProvider_1.httpProvider.get(`/company/${companyId}/investor-relations/invitations?keyword=${keyword}&page=${page}&rowsPerPage=${rowsPerPage}&sortOrder=${sortOrder}`);
            return response.data;
        });
    }
    activateAsicConnection(companyId) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield HttpProvider_1.httpProvider.patch(`/company/${companyId}/activate-asic`);
            return response.data;
        });
    }
    getAsicConnectionStatus(companyId) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield HttpProvider_1.httpProvider.get(`/company/${companyId}/asic-status`);
            return response.data.payload;
        });
    }
    getCas360ConnectionStatus(companyId) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield HttpProvider_1.httpProvider.get(`/company/${companyId}/cas360-status`);
            return response.data.payload;
        });
    }
    getTvlConnectionStatus(companyId) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield HttpProvider_1.httpProvider.get(`/company/${companyId}/tvl-status`);
            return response.data.payload;
        });
    }
    getBgl360AuthoriseUrl(companyId) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield HttpProvider_1.httpProvider.get(`/company/${companyId}/bgl360-authorise-url`);
            return response.data;
        });
    }
    bglResync(companyId) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield HttpProvider_1.httpProvider.post(`/company/${companyId}/bgl-resync`);
            return response.data;
        });
    }
    updateAsicData(companyId, adminUserId) {
        return __awaiter(this, void 0, void 0, function* () {
            const reqData = { companyId, adminUserId };
            const response = yield HttpProvider_1.httpProvider.patch(`/company/${companyId}/update-asic`, reqData);
            return response.data;
        });
    }
    generateHoldingStatement(companyId, shareholderId, startDate, endDate, timestamp) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield HttpProvider_1.httpProvider.get(`/company/${companyId}/shareholder/${shareholderId}/holding-statement?startDate=${encodeURIComponent(startDate)}&endDate=${encodeURIComponent(endDate)}&timestamp=${encodeURIComponent(timestamp)}`);
                return response.data;
            }
            catch (err) {
                return {
                    status: false,
                    message: err.message,
                    payload: null,
                };
            }
        });
    }
    getCompanyPlanInfo(companyId) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield HttpProvider_1.httpProvider.get(`/company/${companyId}/plan-info`);
            return response.data;
        });
    }
    inviteNewShareholder(companyId, inviteNewShareholderRequestBody) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield HttpProvider_1.httpProvider.post(`/company/${companyId}/invite-shareholder`, inviteNewShareholderRequestBody);
            return response.data;
        });
    }
    getStripeCustomerPortalUrl(companyId, returnPage) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield HttpProvider_1.httpProvider.get(`/company/${companyId}/stripe-customer-portal${returnPage ? `?returnPage=${returnPage}` : ""}`);
            return response.data;
        });
    }
    getActivityLogs(companyId, sortBy, sortOrder, skip, limit) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield HttpProvider_1.httpProvider.get(`/company/${companyId}/activity-logs?sortBy=${sortBy}&sortOrder=${sortOrder}&skip=${skip}&limit=${limit}`);
            return response.data;
        });
    }
    getInvestorContacts(companyId, keyword, page, rowsPerPage, sortOrder, sortBy) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield HttpProvider_1.httpProvider.get(`/company/${companyId}/investor-relations/contacts?keyword=${keyword}&page=${page}&rowsPerPage=${rowsPerPage}&sortOrder=${sortOrder}&sortBy=${sortBy}`);
            return response.data;
        });
    }
    getAllContacts(companyId) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield HttpProvider_1.httpProvider.get(`/company/${companyId}/investor-relations/contacts/all`);
            return response.data;
        });
    }
    createAnnouncement(companyId, createAnnouncementRequestBody) {
        return __awaiter(this, void 0, void 0, function* () {
            const formData = new FormData();
            formData.append("subject", createAnnouncementRequestBody.subject);
            formData.append("body", createAnnouncementRequestBody.body);
            formData.append("includeShareholders", createAnnouncementRequestBody.includeShareholders.toString());
            formData.append("includeNoteholders", createAnnouncementRequestBody.includeNoteholders.toString());
            formData.append("includeOptionholders", createAnnouncementRequestBody.includeOptionholders.toString());
            Array.from(createAnnouncementRequestBody.files).forEach((file) => {
                formData.append("files", file, file.name);
            });
            const response = yield HttpProvider_1.httpProvider.post(`/company/${companyId}/announcement`, formData);
            return response.data;
        });
    }
    uploadDocument(companyId, uploadedByUserId, pdfFile, shareholderId, expiryDate, documentType) {
        return __awaiter(this, void 0, void 0, function* () {
            const formData = new FormData();
            formData.append("pdf", pdfFile, pdfFile === null || pdfFile === void 0 ? void 0 : pdfFile.name);
            if (shareholderId) {
                formData.append("shareholderId", shareholderId);
            }
            if (expiryDate) {
                formData.append("expiryDate", expiryDate.toISOString());
            }
            if (documentType) {
                formData.append("documentType", documentType);
            }
            const response = yield HttpProvider_1.httpProvider.post(`/company/${companyId}/upload-document/${uploadedByUserId}`, formData);
            return response.data;
        });
    }
    deleteDocument(companyId, documentId) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield HttpProvider_1.httpProvider.delete(`/company/${companyId}/documents/${documentId}`);
            return response.data;
        });
    }
    getCompanyDocuments(companyId, page, rowsPerPage, sortBy, sortOrder) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield HttpProvider_1.httpProvider.get(`/company/${companyId}/documents?page=${page}&rowsPerPage=${rowsPerPage}&sortOrder=${sortOrder}&sortBy=${sortBy}`);
            return response.data;
        });
    }
    getInvestorApplicationDocuments(companyId) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield HttpProvider_1.httpProvider.get(`/company/${companyId}/investor-application-documents`);
            return response.data;
        });
    }
    getShareholderDocuments(companyId, shareholderId) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield HttpProvider_1.httpProvider.get(`/company/${companyId}/documents/${shareholderId}`);
            return response.data;
        });
    }
    getSignedUrlOfDocument(companyId, documentId) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield HttpProvider_1.httpProvider.get(`/company/${companyId}/document/${documentId}`);
            return response.data;
        });
    }
    uploadCompanyLogo(companyId, logoFile) {
        return __awaiter(this, void 0, void 0, function* () {
            // create form data
            const formData = new FormData();
            formData.append("logo", logoFile, logoFile.name);
            const response = yield HttpProvider_1.httpProvider.post(`/company/${companyId}/logo`, formData);
            return response.data;
        });
    }
    setCompanyDisplayName(companyId, name) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield HttpProvider_1.httpProvider.patch(`/company/${companyId}/display-name`, { name });
            return response.data;
        });
    }
    deleteTransactionsOfShareholder(companyId, shareholderIds) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield HttpProvider_1.httpProvider.delete(`/company/${companyId}/transactions/`, { shareholderIds });
            return response.data;
        });
    }
    deleteTransactionsOfACompany(companyId) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield HttpProvider_1.httpProvider.delete(`/company/${companyId}/transactions/all`);
            return response.data;
        });
    }
    getOfficeholders(companyId) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield HttpProvider_1.httpProvider.get(`/company/${companyId}/appointments`);
            return response.data;
        });
    }
    getOfficeholderById(companyId, officeholderId) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield HttpProvider_1.httpProvider.get(`/company/${companyId}/appointments/${officeholderId}`);
            return response.data;
        });
    }
    appointOfficeholder(companyId, appointOfficeholderRequestBody) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield HttpProvider_1.httpProvider.post(`/company/${companyId}/appointments`, appointOfficeholderRequestBody);
            return response.data;
        });
    }
    updateOfficeholder(companyId, officeholderId, editOfficeholderRequestBody) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield HttpProvider_1.httpProvider.put(`/company/${companyId}/appointments/${officeholderId}`, editOfficeholderRequestBody);
            return response.data;
        });
    }
    removeOfficeholders(companyId, removeOfficeholdersRequestBody) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield HttpProvider_1.httpProvider.delete(`/company/${companyId}/appointments`, removeOfficeholdersRequestBody);
            return response.data;
        });
    }
    createNewNotes(companyId, createNotesData) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield HttpProvider_1.httpProvider.put(`/company/${companyId}/notes`, createNotesData);
            return response.data;
        });
    }
    getAllNotes(companyId) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield HttpProvider_1.httpProvider.get(`/company/${companyId}/notes`);
            return response.data;
        });
    }
    issueNotesToExistingShareholder(companyId, shareholderId, transaction) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield HttpProvider_1.httpProvider.put(`/company/${companyId}/notes/${shareholderId}`, transaction);
            return response.data;
        });
    }
    issueNotesToNewShareholder(companyId, shareholder) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield HttpProvider_1.httpProvider.post(`/company/${companyId}/notes`, shareholder);
            return response.data;
        });
    }
    getNotesRegister(companyId, keyword, activeClassId, page, rowsPerPage, sortBy, sortOrder) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield HttpProvider_1.httpProvider.get(`/company/${companyId}/register/notes?keyword=${keyword}&activeClassId=${activeClassId}&page=${page}&rowsPerPage=${rowsPerPage}&sortBy=${sortBy}&sortOrder=${sortOrder}`);
            return response.data;
        });
    }
    getNotesCsvData(companyId) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield HttpProvider_1.httpProvider.get(`/company/${companyId}/register/notes/csv`);
            return response.data;
        });
    }
    deleteNote(companyId, noteId) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield HttpProvider_1.httpProvider.delete(`/company/${companyId}/notes/${noteId}`);
            return response.data;
        });
    }
    getNotesNamesAndCodes(companyId) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield HttpProvider_1.httpProvider.get(`/company/${companyId}/notes/names-and-codes`);
            return response.data;
        });
    }
    getOptionGrantDetailsByShareholderId(companyId, shareholderId, optiongrantId) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield HttpProvider_1.httpProvider.get(`/company/${companyId}/investor-detail/${shareholderId}/options/grant-detail/${optiongrantId}`);
            return response.data;
        });
    }
    getOptionUnitsDetailsByGrantId(companyId, shareholderId, optiongrantId) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield HttpProvider_1.httpProvider.get(`/company/${companyId}/investor-detail/${shareholderId}/options/grant-detail-units/${optiongrantId}`);
            return response.data;
        });
    }
    getNoteDetailsByShareholderId(companyId, shareholderId, notetransactionId) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield HttpProvider_1.httpProvider.get(`/company/${companyId}/investor-detail/${shareholderId}/notes/${notetransactionId}`);
            return response.data;
        });
    }
    createNewOptionsPool(companyId, createNewOptionsPoolData) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield HttpProvider_1.httpProvider.post(`/company/${companyId}/option-pool`, createNewOptionsPoolData);
            return response.data;
        });
    }
    updateOptionsPool(companyId, optionsPoolId, updateOptionsPoolData) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield HttpProvider_1.httpProvider.patch(`/company/${companyId}/option-pool/${optionsPoolId}`, updateOptionsPoolData);
            return response.data;
        });
    }
    convertNotes(companyId, shareholderId, notesTransactionId, transaction) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield HttpProvider_1.httpProvider.post(`/company/${companyId}/investor-detail/${shareholderId}/notes-convert/${notesTransactionId}`, transaction);
            return response.data;
        });
    }
    removeOptionsPool(companyId, optionsPoolId) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield HttpProvider_1.httpProvider.delete(`/company/${companyId}/option-pool/${optionsPoolId}`);
            return response.data;
        });
    }
    getOptionPoolNames(companyId, type) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield HttpProvider_1.httpProvider.get(`/company/${companyId}/option-pool?type=${type}`);
            return response.data;
        });
    }
    getOptionPools(companyId) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield HttpProvider_1.httpProvider.get(`/company/${companyId}/option-pool/all`);
            return response.data;
        });
    }
    createNewOptionGrant(companyId, optionGrantData) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield HttpProvider_1.httpProvider.post(`/company/${companyId}/option-grant`, optionGrantData);
            return response.data;
        });
    }
    createOptionUnit(companyId, optionUnitData) {
        return HttpProvider_1.httpProvider.post(`/company/${companyId}/option-unit/create`, optionUnitData).then((res) => res.data);
    }
    deleteOptionUnit(companyId, optionUnitId) {
        return HttpProvider_1.httpProvider.delete(`/company/${companyId}/option-unit/${optionUnitId}/delete`).then((res) => res.data);
    }
    getOptionRegisterForOptionholder(companyId, optionholderId) {
        return HttpProvider_1.httpProvider.get(`/company/${companyId}/option-register/${optionholderId}`).then((res) => res.data);
    }
    getOptionRegister(companyId, search, shareclassId, sortBy, sortOrder, page, rowsPerPage) {
        return HttpProvider_1.httpProvider
            .get(`/company/${companyId}/option-register?search=${search}&shareclassId=${shareclassId}&page=${page}&rowsPerPage=${rowsPerPage}&sortBy=${sortBy}&sortOrder=${sortOrder}`)
            .then((res) => res.data);
    }
    getOptionsCsvData(companyId) {
        return __awaiter(this, void 0, void 0, function* () {
            return HttpProvider_1.httpProvider.get(`/company/${companyId}/option-register/csv`).then((res) => res.data);
        });
    }
    getOptionPoolNamesAndCodes(companyId) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield HttpProvider_1.httpProvider.get(`/company/${companyId}/options/names-and-codes`);
            return response.data;
        });
    }
    exerciseOptions(companyId, optionGrantId, exerciseData) {
        return __awaiter(this, void 0, void 0, function* () {
            return HttpProvider_1.httpProvider
                .post(`/company/${companyId}/option-grant/${optionGrantId}/exercise`, { exerciseData })
                .then((res) => res.data);
        });
    }
    updateGrant(companyId, optionGrantId, updateData) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield HttpProvider_1.httpProvider.post(`/company/${companyId}/option-grant/${optionGrantId}/update`, updateData);
            return response.data;
        });
    }
    deleteGrant(companyId, optionGrantId) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield HttpProvider_1.httpProvider.delete(`/company/${companyId}/option-grant/${optionGrantId}/delete`);
            return response.data;
        });
    }
    createNewFundraise(companyId, createFundraiseData) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield HttpProvider_1.httpProvider.put(`/company/${companyId}/fundraises`, createFundraiseData);
            return response.data;
        });
    }
    paySubscriptionAgreement(companyId, paySubscriptionAgreementRequestBody) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield HttpProvider_1.httpProvider.post(`/company/${companyId}/payment-details`, paySubscriptionAgreementRequestBody);
            return response.data;
        });
    }
    getFundraiseByFundraiseId(companyId, fundraiseId) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield HttpProvider_1.httpProvider.get(`/company/${companyId}/fundraises/${fundraiseId}`);
            return response.data;
        });
    }
    generateReconciliationReport(companyId, fundraiseRound, timestamp) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield HttpProvider_1.httpProvider.post(`/company/${companyId}/fundraises/${fundraiseRound._id}/reconciliation-report?timestamp=${encodeURIComponent(timestamp)}`, fundraiseRound);
                return response.data;
            }
            catch (err) {
                return {
                    status: false,
                    message: err.message,
                    payload: null,
                };
            }
        });
    }
    getHighestShareCertificateNumber(companyId) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield HttpProvider_1.httpProvider.get(`/company/${companyId}/share-certificate-number`);
            return response.data;
        });
    }
    getFundraiseCsvDataByFundraiseId(companyId, fundraiseId) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield HttpProvider_1.httpProvider.get(`/company/${companyId}/fundraise/${fundraiseId}/csv`);
            return response.data;
        });
    }
    createFundraiseBankAccount(companyId, bankAccount) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield HttpProvider_1.httpProvider.post(`/company/${companyId}/create-bank-account`, bankAccount);
            return response.data;
        });
    }
    updateCompanyWalletAddress(companyId, companyWalletAddress) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield HttpProvider_1.httpProvider.post(`/company/${companyId}/update-company-wallet-address`, {
                companyWalletAddress,
            });
            return response.data;
        });
    }
    getAllInvestors(companyId, keyword, page, rowsPerPage, sortBy, sortOrder, status = [mystake_common_sdk_1.ShareholderStatus.ACCEPTED]) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield HttpProvider_1.httpProvider.get(`/company/${companyId}/investors?keyword=${keyword}&page=${page}&rowsPerPage=${rowsPerPage}&sortBy=${sortBy}&sortOrder=${sortOrder}&status=${status}`);
            return response.data;
        });
    }
    getShareholderTransactionsByAuctionId({ companyId, shareholderId, auctionId, sortBy, sortOrder, page, rowsPerPage, phase = "All", }) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield HttpProvider_1.httpProvider.get(`/company/${companyId}/auction-transactions/${shareholderId}/${auctionId}?sortBy=${sortBy}&sortOrder=${sortOrder}&page=${page}&rowsPerPage=${rowsPerPage}&phase=${phase}`);
            return response.data;
        });
    }
    updateCompanyContactEmail(companyId, email) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield HttpProvider_1.httpProvider.patch(`/company/${companyId}/update-contact-email`, { email });
            return response.data;
        });
    }
    setLiquidityProvider(companyId, { shareholderId, }) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield HttpProvider_1.httpProvider.post(`/company/${companyId}/set-liquidity-provider`, {
                shareholderId,
            });
            return response.data;
        });
    }
    getLiquidityProvider(companyId) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield HttpProvider_1.httpProvider.get(`/company/${companyId}/get-liquidity-provider`);
            return response.data;
        });
    }
    inviteInvestor(companyId, data) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield HttpProvider_1.httpProvider.post(`/company/${companyId}/invite-investor`, data);
            return response.data;
        });
    }
    generateDistributionABA(companyId, data) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield HttpProvider_1.httpProvider.post(`/company/${companyId}/distributions/generate-aba`, data);
            return response.data;
        });
    }
    processDistributionReinvestment(companyId, data) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield HttpProvider_1.httpProvider.post(`/company/${companyId}/distributions/reinvestment`, data);
            return response.data;
        });
    }
}
exports.CompanyServiceLive = CompanyServiceLive;
//# sourceMappingURL=CompanyServiceLive.js.map